<template lang="pug">
  .simple.user-form.container.mx-auto.px-4
    slot(name="header")
    component.user-container(:is="tag")
      h3.text-center.mb-6.text-2xl(v-if="! isAuthenticated") Anmelden
      Authenticate(:registration="false")
        .form-grid
          .sidebar
            ul
              li
                router-link.button.inline-block.w-full.is-link(to="bestellungen" :disabled="true") Bestellungen
              li
                router-link.button.inline-block.w-full.is-link(to="ruecksendungen" :disabled="true") Rücksendungen
              li
                router-link.button.inline-block.w-full.is-link(to="account") Account
              li
                router-link.button.inline-block.w-full.is-link(to="adressen") Adressen
          main.form
            router-view(:key="$route.path")
    slot(name="footer")
</template>

<script>
import { mapGetters } from 'vuex';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';

export default {
  name: 'UserForm',
  components: {
    Authenticate
  },
  computed: {
    tag() {
      let tag = 'main';
      if (this.isAuthenticated) tag = 'div';
      return tag;
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated'
    })
  }
};
</script>

<style lang="sass" scoped>
.user-form
  padding-top: 1rem
  @screen md
    padding-top: 3rem
    padding-bottom: 4rem

  .user-container
    // padding: 1rem
    // @screen lg
    //   padding: 1rem 3rem

  .form-grid
    display: grid
    grid-gap: 1rem
    @screen md
      grid-template-rows: auto
      grid-template-columns: max-content auto
    .sidebar
      li
        margin-bottom: 3px
        a
          display: flex
          justify-content: center
          align-items: center
          text-decoration: none

          // width: 100%
          // padding: 4px 6px 6px
          // border: 1px solid var(--color-primary)
          // display: inline-block
          // line-height: 1
          // text-align: left
          // font-weight: bold
          // transition: background .15s ease, color .15s ease
          // &:hover
          //   // @apply outline-black-sm
          // &.active
          //   background: var(--color-primary)
          //   --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
          //   color: hsl(0, 0%, var(--switch))

  ::v-deep
    a.panel
      text-decoration: none
</style>
